import { PreviewVariant } from '../../preview-common/preview-variant.interface';
import { YoutubeVideoVariablesTablePreviewComponent } from './variables-table/variables-table.component';
import { YoutubeVideoPartnersInStreamDesktopPreviewComponent } from './video-partners-in-stream-desktop/video-partners-in-stream-desktop.component';
import { YoutubeVideoPartnersInStreamMobilePreviewComponent } from './video-partners-in-stream-mobile/video-partners-in-stream-mobile.component';
import { YoutubeVideoInStreamTvPreviewComponent } from './youtube-in-stream-tv/youtube-in-stream-tv.component';
import { YoutubeVideoInStreamMobilePreviewComponent } from './youtube-in-stream-mobile/youtube-in-stream-mobile.component';
import { YoutubeVideoInStreamDesktopPreviewComponent } from './youtube-in-stream-desktop/youtube-in-stream-desktop.component';

/**
 * The single source of truth for YouTube Video Ad preview variants. Add a
 * preview by creating a variant component and appending one entry here.
 */
export const YOUTUBE_VIDEO_VARIANTS: PreviewVariant[] = [
  {
    id: 'youtube-desktop-01',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube in-stream',
    component: YoutubeVideoInStreamDesktopPreviewComponent,
  },
  // // ENABLE IF YOU WANT TO DEBUG
  // {
  //   id: 'variables-debug',
  //   platform: 'youtube',
  //   device: 'desktop',
  //   label: 'Variables (debug)',
  //   component: YoutubeVideoVariablesTablePreviewComponent,
  // },
  {
    id: 'display-desktop-01',
    platform: 'display',
    device: 'desktop',
    label: 'Google video partners in-stream',
    component: YoutubeVideoPartnersInStreamDesktopPreviewComponent
  },
  {
    id: 'display-mobile-01',
    platform: 'display',
    device: 'mobile',
    label: 'Google video partners in-stream',
    component: YoutubeVideoPartnersInStreamMobilePreviewComponent
  },
  {
    id: 'youtube-tv-01',
    platform: 'youtube',
    device: 'tv',
    label: 'YouTube in-stream',
    component: YoutubeVideoInStreamTvPreviewComponent
  },
  {
    id: 'youtube-mobile-01',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube in-stream',
    component: YoutubeVideoInStreamMobilePreviewComponent,
  },
];
